<div class="page">
    <div class="container">
        <div class="top_area">
            <div class="row row_ai_center">
                <div class="col-9 left_info row row_ai_center fz_m"><span>Номер заказа:</span>
                    <div class="skeleton_container" *ngIf="isLoading" style="width: 100px;"><app-skeleton
                            height="20"></app-skeleton></div>
                    <div class="skeleton_container" *ngIf="isLoading" style="width: 100px;"><app-skeleton
                            height="20"></app-skeleton></div>
                    <span>{{order.code}}</span><span class="status"
                        [ngClass]="changeOrderStatusesColor(order.status)">{{getOrderStatuses(order.status)}}</span>
                </div>
                <div class="col-15 buttons row">
                    <ul class="btns_list row fz_s">
                        <li *ngIf="order.status == 'New'"><button (click)="openModal('payment')" type="button"
                                class="btn btn_cancel row row_ai_center">Оплатить<span
                                    class="material-symbols-outlined fz_l">
                                    payments
                                </span></button></li>
                        <li><button type="button" disabled class="btn btn_cancel row row_ai_center">Отправить письмо
                                <span class="material-symbols-outlined fz_l">
                                    mail
                                </span></button></li>
                        <li><button type="button" disabled class="btn btn_cancel row row_ai_center">Доставить <span
                                    class="material-symbols-outlined fz_l">
                                    local_shipping
                                </span></button></li>
                        <li><button type="button" disabled class="btn btn_cancel row row_ai_center">Распечатать <span
                                    class="material-symbols-outlined fz_l">
                                    print
                                </span></button></li>
                        <li *ngIf="order.status !== 'New' && order.status !== 'Cancelled' && order.status"><button
                                type="button" (click)="openModal('cancel')"
                                class="btn btn_red row row_ai_center color_red">Отменить заказ <span
                                    class="material-symbols-outlined fz_l">
                                    keyboard_return
                                </span></button></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="main_content">
            <div class="row main_info">
                <div class="col-9"><app-order-info-card [isLoading]="isLoading" [orderOriginal]="orderOriginal" [order]="order"></app-order-info-card>
                </div>
                <div class="col-15">
                    <div class="skeleton_container" *ngIf="isLoading" style="width: 100%;"><app-skeleton height="445"
                            borderRadius="8px"></app-skeleton></div><app-comments-card *ngIf="order.customerId"
                        [customerId]="order.customerId"></app-comments-card>
                </div>
            </div>
            <div class="table_area">
                <div class="table_item">
                        <h3 class="fz_l table_title">Подписки</h3>
                        <app-table (modalProlong)="getOrder()" prolong="prolong" [dataMissing]="dataMissingSubscriptions" [heightTable]="heightTable" [data]="subscriptions" [columns]="columnsSubscriptions"></app-table>
                </div>
                <div class="table_item">
                    <h3 class="fz_l table_title">Товары</h3>
                    <app-table prolong="" [dataMissing]="dataMissingProducts" [heightTable]="heightTable"
                        [data]="products" [columns]="columnsProducts"></app-table>
                </div>
                <div class="table_item pos_relative">
                    <div class="in_progress color_green fz_title">В процессе</div>
                    <div class="in_progress_section">
                        <h3 class="fz_l table_title">Транзакции</h3>
                        <app-table prolong="" [heightTable]="heightTable"></app-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal-payment-order [order]="order" *ngIf="(modalService.modalState$ | async) == 'payment'" (change)="getOrder()"
    [orderId]="orderId"></app-modal-payment-order>
<app-modal-order-cancel *ngIf="(modalService.modalState$ | async) == 'cancel'" (change)="getOrder()" [order]="order"
    [orderId]="orderId"></app-modal-order-cancel>
<app-toastr></app-toastr>